import React, { useEffect, useRef } from "react"

export const ScrollIntoViewOnTrigger = ({ trigger }) => {
  const topRef = useRef(null)

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        block: "end"
      })
    }
  }, [trigger])

  return <div ref={topRef} />
}
